import { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { loadScript } from "../lib/script";

export function GoogleSignIn() {
  const ref = useRef<HTMLDivElement>(null);
  const [error, setError] = useState("");
  const { setUser } = useAuth();
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  useEffect(() => {
    if (!clientId || !ref.current) return;
    let active = true;
    void loadScript("https://accounts.google.com/gsi/client?hl=en").then(() => {
      if (!active || !ref.current || !window.google) return;
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
          setError("");
          void api.googleLogin(response.credential).then(setUser).catch((reason: Error) => setError(reason.message));
        }
      });
      window.google.accounts.id.renderButton(ref.current, {
        theme: "outline", size: "large", shape: "pill", text: "continue_with", width: 280, locale: "en"
      });
    }).catch((reason: Error) => setError(reason.message));
    return () => { active = false; };
  }, [clientId, setUser]);

  if (!clientId) return <div className="config-note">Add <code>VITE_GOOGLE_CLIENT_ID</code> to enable Google sign-in.</div>;
  return <div className="signin-wrap"><div ref={ref} />{error && <p className="form-error">{error}</p>}</div>;
}
